import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Tag, Text } from '@reveni-io/reveni-ui'

import { getReasonLabel, getReasonTagColors } from '@/metrics/helpers/helpers'

const SizingIssuesReasonTag = ({ reason }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const colors = getReasonTagColors(reason, theme)

  return (
    <Tag backgroundColor={colors.background} borderColor={colors.border}>
      <Text type="bodyMMedium" color={colors.text}>
        {getReasonLabel(reason, t)}
      </Text>
    </Tag>
  )
}

export default SizingIssuesReasonTag
